import Bugsnag from '@bugsnag/js';
import { ref, watch } from 'vue';

import { useTemplate } from '../store/templateData';

const RELOAD_TIMES_KEY = 'handsup-reload-times';

// global shared reload times
export const reloadTimes = ref(parseInt(sessionStorage.getItem(RELOAD_TIMES_KEY) ?? '0', 10));
watch(reloadTimes, () => sessionStorage.setItem(RELOAD_TIMES_KEY, (reloadTimes.value.toString())));

export const useTraceScheduledPostBug = (triggeredFrom: string) => {
  const notify = (additionalReport: any) => {
    if (reloadTimes.value < 3 || reloadTimes.value > 10) { return; }

    const { handsupConfig, scheduledPostList } = useTemplate();

    Bugsnag.notify(new Error(JSON.stringify({
      handsupConfig: handsupConfig.value,
      scheduledPostList: scheduledPostList.value,
      triggeredFrom,
      additionalReport,
    })));
  };

  return {
    notify,
  };
};
